import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr'
import { ToastService } from './toast.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  url = environment.apiUrl;
  private hubConnection: signalR.HubConnection;
  constructor(public toastService: ToastService) {
    this.hubConnection = new signalR.HubConnectionBuilder()
    .configureLogging(signalR.LogLevel.None)
      .withUrl(this.url + 'notify')
      .build();
    this.hubConnection.on('SendNotificationToUser', (title,notification) => {
     
      this.toastService.add(notification);

    });
    this.hubConnection.start()
      .catch(err => console.log(err));
  }


}
